module.exports = __webpack_public_path__ + "static/media/cloud-music.3d6cf78a.svg";